import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import de from "vuetify/src/locale/de";
import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "md",
  },
  lang: {
    locales: {
      de: {
        ...de,
        noDataText: "Keine Daten gefunden",
        dataIterator: {
          ...(de as any).dataIterator,
          noResultsText: "Keine Daten gefunden",
        },
        dataTable: {
          ...(de as any).dataTable,
          noResultsText: "Keine Daten gefunden",
        },
      },
    },
    current: "de",
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        // Vuetify standard tokens
        primary: "#1c3f57",
        secondary: "#589FE7",
        background: "#FFFFFF",
        surface: "#FFFFFF",
        onSurface: "#212121",
        success: "#00c91f",
        warning: "#ffa900",
        error: "#f93145",
        info: "#2196F3",
        rowHover: "#eeeeee",

        // Company-specific tokens
        bpbLightGrey: "#E0E0E0",
        bpbDarkGrey: "#A6A6A6",
        bpbPrimaryLight: "#589FE7", //TODO we
        bpbPrimary: "#1c3f57",
        bpbSideBar: "#1c3f57",
        bpbInfo: "#2196F3", // TODO we need new color
        bpbSuccess: "#00c91f",
        bpbWarn: "#ffa900",
        bpbDanger: "#f93145",
        secandaRed: "#9b193f", // SECANDA ROT

        disabledBg: "#f3f3f3",
        disabledText: "#000000",
      },
      dark: {
        primary: "#2B5A7A",
        secondary: "#7BB3EA",
        background: "#121212",
        surface: "#1E1E1E",
        onSurface: "#FFFFFF",
        success: "#4CAF50",
        warning: "#FFB74D",
        error: "#EF5350",
        info: "#42A5F5",
        rowHover: "#616161",
        accent: "#82b1ff",

        // Company-specific tokens
        bpbLightGrey: "#424242",
        bpbDarkGrey: "#757575",
        bpbPrimaryLight: "#7BB3EA",
        bpbPrimary: "#2B5A7A",
        bpbSideBar: "#1c3f57",
        bpbInfo: "#42A5F5",
        bpbSuccess: "#4CAF50",
        bpbWarn: "#FFB74D",
        bpbDanger: "#EF5350",
        secandaRed: "#9b193f",

        disabledBg: "#333333",
        disabledText: "#e0e0e0",
      },
    },
  },
});
